import React from 'react';

// Placeholder for social icons
const SocialIcon = ({ platform }) => <a href="#" style={{ textDecoration: 'none', color: '#ecf0f1', margin: '0 0.5rem' }}>{platform}</a>;


const TemplateFooter3 = ({ branding }) => {
  const styles = {
    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1.5rem 2rem',
      backgroundColor: '#343a40', // Dark grey
      color: '#adb5bd', // Light grey text
      fontFamily: 'Verdana, sans-serif',
      fontSize: '0.9rem'
    },
    copyright: {
        margin: 0
    },
    socials: {
        display: 'flex'
    }
  };

  return (
    <footer style={styles.footer}>
      <p style={styles.copyright}>&copy; {new Date().getFullYear()} Zotrai</p>
      <div style={styles.socials}>
        <SocialIcon platform="Facebook" />
        <SocialIcon platform="Instagram" />
        <SocialIcon platform="Twitter" />
      </div>
    </footer>
  );
};

export default TemplateFooter3;